import React from "react";
import BasicTextFormatting from "./BasicTextFormatting";
import Highlighters from "./Highlighters";
import TextAlignment from "./TextAlignment";
import Lists from "./Lists";
import Links from "./Links";
import Advanced from "./Advanced";
import History from "./History";
import InsertVariables from "../MenuItems/Insertvariables";
import { insertOptions } from "../config/constants";

const EditorMenu = ({
	minimalistic,
	className,
	editor,
	variables,
	customVariablesList,
	disabled,
	showHighlighters,
	showTextAlignment,
	showLists,
	showLinks,
	showHistory
}) => {
	return (
		<>
			<div className={`editor-menu-container w-100${className ? ` ${className}` : ""}`}>
				{variables && (
					<InsertVariables
						options={
							customVariablesList && customVariablesList.length
								? customVariablesList
								: insertOptions
						}
						onSelect={variable => {
							editor.chain().focus().insertContent(variable.value).run();
						}}
						disabled={disabled}
					/>
				)}
				<BasicTextFormatting editor={editor} disabled={disabled} />
				{showHighlighters && <Highlighters editor={editor} disabled={disabled} />}
				{showTextAlignment && <TextAlignment editor={editor} disabled={disabled} />}
				{(showLists || !minimalistic) && <Lists editor={editor} disabled={disabled} />}
				{showLinks && <Links editor={editor} disabled={disabled} />}
				{!minimalistic && <Advanced editor={editor} disabled={disabled} />}
				{(showHistory || !minimalistic) && <History editor={editor} disabled={disabled} />}
			</div>
			<style>{`
                .editor-menu-container {
                    padding: 10px 5px;
                    display: flex;
                    flex-wrap: wrap;
                    border-bottom: 1px solid #CCC;
                }

                .editor-menu-container .editor-menu-box {
                    display: flex;
                    margin: 0px 5px;
                }

                .editor-menu-container .editor-menu-box .editor-menu-item {
                    cursor: pointer;
                    color: #222f3e;
                    outline: none;
                    border: none;
                    background: #FFF;
                    padding: 5px 10px;
                    margin-right: 3px;
                }

                .editor-menu-container .editor-menu-box .is-active {
                    outline: none;
                    border: none;
                    padding: 5px 10px;
                    background: #a6ccf7;
                }

                .editor-menu-container .editor-menu-box .editor-menu-item:hover {
                    background: #cce2fa;
                }

                .editor-menu-container .editor-menu-box .editor-menu-item:disabled {
                    color: #CCC;
                }
            `}</style>
		</>
	);
};

export default EditorMenu;
